import { EnumResolver } from '../../../../commons/enums/enum-resolver.js';

// @lib-export
var ApplicationUserTypeVo;
(function (ApplicationUserTypeVo) {
    ApplicationUserTypeVo["CUSTOMER_APP"] = "CUSTOMER_APP";
    ApplicationUserTypeVo["USER_APP"] = "USER_APP";
})(ApplicationUserTypeVo || (ApplicationUserTypeVo = {}));
const APPLICATION_USER_TYPE_VO_RESOLVER = new EnumResolver(`ApplicationUserTypeVo`, Object.entries(ApplicationUserTypeVo));

export { APPLICATION_USER_TYPE_VO_RESOLVER, ApplicationUserTypeVo };
//# sourceMappingURL=application-user-type-vo.js.map
